module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.$store.state.config.availableDepartments) ? _c('div', {
    staticClass: "economy-learning-potential"
  }, [(_vm.$store.getters.getAvailableDepartments.length > 1) ? _c('div', {
    staticClass: "has-departments"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('compare-keyfigures')], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-6"
  }, [_c('compare-revenue')], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6"
  }, [_c('compare-coverage-percent')], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-6"
  }, [_c('compare-coverage')], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6"
  }, [_c('compare-coverage-per-hour')], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('compare-customer-hours')], 1)])]) : _c('div', {
    staticClass: "no-departments"
  }, [_vm._v("\n        Virksomheden har ingen afdelinger at sammenligne.\n    ")])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2c7820ba"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/economy/learning/compare.vue
// module id = 832
// module chunks = 0